






















































































import { Component, Prop, Vue } from 'vue-property-decorator';

import ProjectBreadcrumb from '@/views/components/projects/ProjectBreadcrumb.vue';
import { IProjectMetadata } from '@/interfaces/report';

import { lccaStore, projectStore } from '@/store/store';

import NewAsphaltScenarioInfo from '@/modules/design/views/asphalt/1-AsphaltScenarioInfo.vue';
import NewAsphaltDesignParameters from '@/modules/design/views/asphalt/2-AsphaltDesignParameters.vue';
import { UnitSystem } from '@/interfaces/units';
import ErrorDisplay from '@/views/components/projects/ErrorDisplay.vue';
import { clearAllHttpErrors } from '@/lib/util/errors';


Component.registerHooks([
  'beforeRouteEnter',
]);

@Component({
  components: {
    ErrorDisplay,
    ProjectBreadcrumb,
    ScenarioInfo: NewAsphaltScenarioInfo,
    DesignParameters: NewAsphaltDesignParameters,
  },
})
export default class LccaScenarioContainer extends Vue {
  @Prop() pages!: { link: string, text: string }[];

  @Prop() id!: number;

  get scenario() {
    console.log('retrieving scenario');
    return lccaStore.currentScenario;
  }

  projectMetadata: IProjectMetadata | null = null;

  created() {
    clearAllHttpErrors();
    lccaStore.loadCurrentScenario(this.id).then((scenario) => {
      lccaStore.setDisplayUnits(scenario.displayUnits);
      projectStore.getProjectMetadata(scenario.project).then((meta) => this.projectMetadata = meta);
    });
  }

  get currentUnitSystemIsImperial() {
    return lccaStore.displayUnits === UnitSystem.Imperial;
  }

  saveUnitSelection() {
    console.log('Saving Unit Selection IN LccaScenarioContainer', this.currentUnitSystemIsImperial);
    if (this.currentUnitSystemIsImperial) {
      lccaStore.setDisplayUnits(UnitSystem.Metric);
    } else {
      lccaStore.setDisplayUnits(UnitSystem.Imperial);
    }
  }
}
